import { tv } from 'tailwind-variants';

export const applicationsHeadingStyleVariant = 'h3' as const;

export const pageApplicationsVariants = tv({
  slots: {
    root: '',
    container: 'gap-lg px-md py-xl md:px-4xl md:py-3xl',
    header: '',
    headingGroup: 'gap-xs',
    heading: 'text-secondary-400!',
    subheading: 'text-secondary-500',
    ctaWrapper: '',
    cta: 'w-full gap-xs text-primary md:w-max',
    ctaText: 'font-body font-semibold',
    ctaIcon: 'size-6',
    content: 'gap-lg md:gap-xl',
    listContainer: 'max-w-300',
    list: 'grid-cols-1 gap-6 md:grid-cols-3',
    card: 'h-full w-full max-h-132 overflow-hidden rounded-md rounded-b-md border border-secondary-100',
    media: 'image-container h-72.5 rounded-t-md bg-secondary-100',
    picture: '',
    image: '',
    cardBody: 'h-59.5 gap-lg px-sm py-md md:min-h-59.5 md:gap-0',
    cardText: 'gap-xs',
    tag: 'hidden',
    cardTitle: 'line-clamp-3 text-lg! font-semibold! text-secondary-400 md:font-bold!',
    cardDescription: 'h-fit line-clamp-3 font-body leading-5 text-secondary-500',
    cardActions: 'justify-end gap-4',
    primaryAction: 'gap-1',
    primaryActionText: 'bg-transparent p-0 font-semibold! text-primary transition-colors hover:no-underline!',
    primaryActionIcon: 'text-primary transition-transform duration-300 ease-in-out group-hover:translate-x-1',
    campaignLink: 'text-sm text-primary hover:underline',
    buttonGroup: 'w-full justify-center gap-3 max-md:w-full',
    button: 'max-md:w-full md:min-w-5xl md:w-max',
  },
  variants: {
    alignment: {
      left: {
        headingGroup: 'items-start text-left',
      },
      center: {
        headingGroup: 'items-center text-center',
      },
      right: {
        headingGroup: 'items-end text-right',
      },
    },
    itemCount: {
      two: {},
      three: {},
      four: {},
    },
  },
  defaultVariants: {
    alignment: 'left',
    itemCount: 'three',
  },
});
